import { render, staticRenderFns } from "./ShopCatalogTabLinks.vue?vue&type=template&id=0f78387f"
import script from "./ShopCatalogTabLinks.vue?vue&type=script&lang=js"
export * from "./ShopCatalogTabLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports